import React from "react";
import FooterComponent from "../../components/Footer";
import HeaderComponent from "../../components/Header";

export type StyleGuideLayoutProps = {
  children: React.ReactNode;
};

const StyleGuideLayout: React.FC<StyleGuideLayoutProps> = ({ children }) => (
  <>
    <HeaderComponent showAboutUs hasBorder />
    {children}
    <FooterComponent />
  </>
);

export default StyleGuideLayout;
